import { ServiceDto } from './servicedto';
import { AdministrativeFeeCatalogTraductionDto } from './administrativefeecatalogtraductiondto';

export class AdministrativeFeeCatalogDto {
    idAdministrativeFeesCatalog?: number;
    registrationCancellationFee?: boolean;
    codeAdministrativeFeeCatalog?: string;
    registrationModificationFee?: boolean;
    splitPaymentRate?: boolean;
    active?: boolean;
    typology?:string;
    serviceDto?: ServiceDto;
    administrativeFeeCatalogTraductionDto?: AdministrativeFeeCatalogTraductionDto[];

    constructor(data?: Partial<AdministrativeFeeCatalogDto>) {
        Object.assign(this, data);
    }

}
